import type { NodeRenderer } from '@contentful/rich-text-react-renderer';
import { INLINES } from '@contentful/rich-text-types';
import type { ReactNode } from 'react';

import {
  isTextEffectEntry,
  textEffectRenderer,
} from '@/components/RichText/TextEffects';
import type { TextEffectCF } from '@/types';

export const embeddedEntryRenderer: NodeRenderer = (node) => {
  if (node.nodeType === INLINES.EMBEDDED_ENTRY) {
    return embeddedInlineEntryRenderer(node.data.target);
  }

  throw new Error(
    `embeddedEntryRenderer is not configured to handle following node properly: ${node}`
  );
};

const embeddedInlineEntryRenderer = (
  entry: TextEffectCF | unknown
): ReactNode => {
  if (isTextEffectEntry(entry)) return textEffectRenderer(entry);

  throw new Error(
    `embeddedInlineEntryRenderer is not configured to handle following entry properly: ${entry}`
  );
};
